export default "__VITE_ASSET__1cQndwtI__"